import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updateCustomerAddress } from '../modules/update_customer_actions';

class CustomerAddress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditOpen:       false,
      shipping_address: {}
    };
    this.toggleEditState       = this.toggleEditState.bind(this);
    this.updateCustomerAddress = this.updateCustomerAddress.bind(this);
  }

  // Store updates in state so we can pass to update method
  handleChange( sLabel, event ) {
    let oActiveUpdate = this.state.shipping_address;
    oActiveUpdate[ sLabel ] = event.target.value;
    this.setState({shipping_address: oActiveUpdate});
  }

  updateCustomerAddress( evt ) {
    evt.preventDefault();

    let oUpdatedAddresses              = {};
    oUpdatedAddresses.shipping_address = this.state.shipping_address;
    this.props.dispatch( updateCustomerAddress( oUpdatedAddresses ));
    this.toggleEditState();
  }

  toggleEditState() {
    this.setState({isEditOpen: !this.state.isEditOpen});
  }

  render() {
    let oShippingLabel  = '';
    let oAddressForm    = '';

    // Ensure state is set before proceeding with the label records ( read only depictions of address/compacted ).
    if ( this.props.customer.shipping_address ) {
      oShippingLabel = (
        <ul className={"list shipping" + (this.state.isEditOpen ? " hidden" : "")}>
          <li>
            {this.props.customer.shipping_address.street}
          </li>
          <li>
            {this.props.customer.shipping_address.city + ", "}
            {this.props.customer.shipping_address.state + " "}
            {this.props.customer.shipping_address.zip}
          </li>
          <li>
            {this.props.customer.shipping_address.code}
          </li>
          <li>
            <span className="edit-link" onClick={this.toggleEditState}>Edit addresses</span>
          </li>
        </ul>
      );

      oAddressForm = (
        <div className={"info-edit-form" + (this.state.isEditOpen ? " showing" : "")} id="shipping-info-edit">
          <div className="list-header">Edit Shipping Address</div>
          <form onSubmit={this.updateCustomerAddress.bind( this )}>
            <input
              type          = "text"
              required
              onChange      = {this.handleChange.bind( this, 'street' )}
              placeholder   = "Shipping Street"
              name ="ship-address"
              defaultValue  = {this.props.customer.shipping_address.street}
            />
            <input
              type          = "text"
              required
              onChange      = {this.handleChange.bind( this, 'city' )}
              placeholder   = "Shipping City"
              name="ship-city"
              defaultValue  = {this.props.customer.shipping_address.city}
            />
            <div className="select-wrapper unselectable">
              <select
                onChange     = {this.handleChange.bind( this, 'state' )}
                required
                name="ship-state"
                defaultValue = {this.props.customer.shipping_address.state}
              >
                <option value="AA">AA - Armed Forces Americas</option>
                <option value="AE">AE - Armed Forces Europe</option>
                <option value="AK">AK - Alaska</option>
                <option value="AL">AL - Alabama</option>
                <option value="AP">AP - Armed Forces Pacific</option>
                <option value="AR">AR - Arkansas</option>
                <option value="AZ">AZ - Arizona</option>
                <option value="CA">CA - California</option>
                <option value="CO">CO - Colorado</option>
                <option value="CT">CT - Connecticut</option>
                <option value="DC">DC - District of Columbia</option>
                <option value="DE">DE - Delaware</option>
                <option value="FL">FL - Florida</option>
                <option value="GA">GA - Georgia</option>
                <option value="HI">HI - Hawaii</option>
                <option value="IA">IA - Iowa</option>
                <option value="ID">ID - Idaho</option>
                <option value="IL">IL - Illinois</option>
                <option value="IN">IN - Indiana</option>
                <option value="KS">KS - Kansas</option>
                <option value="KY">KY - Kentucky</option>
                <option value="LA">LA - Lousiana</option>
                <option value="MA">MA - Massachusetts</option>
                <option value="MD">MD - Maryland</option>
                <option value="ME">ME - Maine</option>
                <option value="MI">MI - Michigan</option>
                <option value="MN">MN - Minnesota</option>
                <option value="MO">MO - Missouri</option>
                <option value="MS">MS - Mississippi</option>
                <option value="MT">MT - Montana</option>
                <option value="NC">NC - North Carolina</option>
                <option value="ND">ND - North Dakota</option>
                <option value="NE">NE - Nebraska</option>
                <option value="NH">NH - New Hampshire</option>
                <option value="NJ">NJ - New Jersey</option>
                <option value="NM">NM - New Mexico</option>
                <option value="NV">NV - Nevada</option>
                <option value="NY">NY - New York</option>
                <option value="OH">OH - Ohio</option>
                <option value="OK">OK - Oklahoma</option>
                <option value="OR">OR - Oregon</option>
                <option value="PA">PA - Pennsylvania</option>
                <option value="PR">PR - Puerto Rico</option>
                <option value="RI">RI - Rhode Island</option>
                <option value="SC">SC - South Carolina</option>
                <option value="SD">SD - South Dakota</option>
                <option value="TN">TN - Tennessee</option>
                <option value="TX">TX - Texas</option>
                <option value="UT">UT - Utah</option>
                <option value="VA">VA - Virginia</option>
                <option value="VT">VT - Vermont</option>
                <option value="WA">WA - Washington</option>
                <option value="WI">WI - Wisconsin</option>
                <option value="WV">WV - West Virginia</option>
                <option value="WY">WY - Wyoming</option>
              </select>
            </div>
            <input
              type         = "text"
              required
              onChange     = {this.handleChange.bind( this, 'zip' )}
              placeholder  = "Shipping Zipcode"
              name         = "ship-zip"
              defaultValue = {this.props.customer.shipping_address.zip}
            />
            <button className="btn-primary">Update</button>
            <span className="button btn-tertiary cancel" onClick={this.toggleEditState}>cancel</span>
          </form>
        </div>
      );
    }

    return(
      <div className="section" id="shipping-info">
        <h4 className="alt">Shipping Information</h4>
        {oShippingLabel}
        {oAddressForm}
      </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'customer': state.customer
    };
}

export default connect(mapStateToProps)(CustomerAddress);



// WEBPACK FOOTER //
// ./src/components/CustomerAddress.jsx